import _objectSpread from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _slicedToArray from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children", "isFullScreenEnabled", "open", "onOpenChange", "defaultOpen"];
import { jsx } from 'react/jsx-runtime';
import * as DropdownMenuPrimitive from '@radix-ui/react-dropdown-menu';
import { useControllableState } from '../../utils/useControllableState.js';
import { FullScreenMenuProvider } from '../menu-utils/responsiveness/FullScreenDropdownMenuContext.js';
/**
 * The Dropdown-menu component displays a menu to the user, such as a set of actions or functions—triggered by a button.
 */

var DropdownMenuRoot = function DropdownMenuRoot(props) {
  var children = props.children,
      isFullScreenEnabled = props.isFullScreenEnabled,
      open = props.open,
      onOpenChange = props.onOpenChange,
      defaultOpen = props.defaultOpen,
      rest = _objectWithoutProperties(props, _excluded);

  var _useControllableState = useControllableState({
    prop: open,
    onChange: onOpenChange,
    defaultProp: defaultOpen
  }),
      _useControllableState2 = _slicedToArray(_useControllableState, 2),
      _useControllableState3 = _useControllableState2[0],
      isMenuOpen = _useControllableState3 === void 0 ? false : _useControllableState3,
      setIsMenuOpen = _useControllableState2[1];

  return jsx(FullScreenMenuProvider, {
    isFullScreenEnabled: isFullScreenEnabled,
    isMenuOpen: isMenuOpen,
    setIsMenuOpen: setIsMenuOpen,
    children: jsx(DropdownMenuPrimitive.Root, _objectSpread(_objectSpread({}, rest), {}, {
      onOpenChange: setIsMenuOpen,
      open: isMenuOpen,
      children: children
    }))
  });
};

DropdownMenuRoot.displayName = 'DropdownMenuRoot';
export { DropdownMenuRoot };